import { render } from "./PlatinumProMovingView.vue?vue&type=template&id=92968ed8"
import script from "./PlatinumProMovingView.vue?vue&type=script&lang=js"
export * from "./PlatinumProMovingView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__